export default "__VITE_ASSET___LKVRf2H__"